import React from "react";

import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import IRatingOverviewSearch from "../../interface/iRatingOverviewSearch";
import SelectCoachInput from "../../../../components/inputs/coach/selectCoachInput";

const SearchCoach = (): React.JSX.Element => {
  const {
    ratingOverviewSearch,
    setRatingOverviewSearch,
  }: {
    ratingOverviewSearch: IRatingOverviewSearch;
    setRatingOverviewSearch: React.Dispatch<
      React.SetStateAction<IRatingOverviewSearch>
    >;
  } = React.useContext(RatingOverviewContext);

  const handleChange = (coach: { label: string; value: number }): void =>
    setRatingOverviewSearch((prevState: any) => ({
      ...prevState,
      coach,
    }));

  return (
    <SelectCoachInput
      disabled={false}
      coach={
        ratingOverviewSearch.coach as {
          label: string;
          value: string | null;
        } | null
      }
      setCoach={handleChange}
    />
  );
};

export default SearchCoach;
